import { TablePaginationConfig } from "antd";
import { citiesApi } from "api/city";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { ITableData, defaultTableData } from "models";
import { ICity } from "models/city";
import { ChangeEvent, useEffect, useState } from "react";

export default function useCity() {
  const { showError } = useNotificationContext();
  const { reloadCity } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<ICity>>(defaultTableData);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [data.page, data.search, reloadCity]);

  const fetchData = async () => {
    setData((prev) => ({ ...prev, loading: true }));
    const { data: response, error } = await citiesApi(
      data.page,
      data.per_page,
      data.search
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response }));
    } else showError(error!.message);
    setData((prev) => ({ ...prev, loading: false }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return { data, handlePageChange, handleSearch };
}
